<div mat-dialog-content>
  <p>Etes-vous certain de vouloir quitter cette page, des modifications n'ont pas étés enregistrées ?</p>
</div>
<div mat-dialog-actions class="dialog-buttons">
  <button mat-stroked-button (click)="refuse()">Annuler</button>
  <button mat-flat-button color="primary" (click)="valid()">Confirmer</button>
</div>